module.exports = __webpack_public_path__ + "img/yelp.bba401c.svg";